import React from "react";
import { PayrollCalendarPayDatesContainer } from "../../containers";

const PayrollCalendar = (props) => {
  return <PayrollCalendarPayDatesContainer {...props} />;
};

export default PayrollCalendar;
